import { BPFormProvider, Input } from '@bpba/form-components';
import { Button, VStack } from '@bpba/ui-components';
import { useForm } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { UrlsBack, UrlsFront } from '../constants/urls';
import useAxios from 'axios-hooks';
import { IUser } from '../types/IUser';
import { SignUpOtpRules } from './SignUpOtpRules';
import { IUserCredentials } from '../types/IUserCredentials';
import { Titulo } from '../components/shared/Titulo';
import { useErrorMessage } from '../components/shared/useErrorMessage';
import { axiosMessageExtractor } from '../config/axiosMessageExtractor';
import { ErrorMessageContainer } from '../components/shared/ErrorMessageContainer';
import { Spinner } from '../components/shared/Spinner';
import { useEffect } from 'react';
import { EMAIL_LABEL, OTP_LABEL } from '../constants/form';
import { AuthLink } from './AuthLink';

type IOtpResponse = {
  customer: IUser;
};

export const OTPForm = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const methods = useForm<IUserCredentials>({ values: { email: state?.email, otp: '' } });
  const [{ loading }, post] = useAxios<IOtpResponse>({ url: UrlsBack.SignUpValidate, method: 'Post' }, { manual: true });
  const [errorMessage, setErrorMessage, showError, clearError] = useErrorMessage(axiosMessageExtractor);

  useEffect(() => {
    if (!state && navigate) {
      navigate(UrlsFront.SignUpHome);
    }
  }, [state, navigate]);

  const onSubmit = async ({ otp }: any) => {
    clearError();

    await post({ data: { otp } })
      .then((data) => {
        const params: IUser = { ...data.data?.customer, name: `${data.data?.customer?.firstname} ${data.data?.customer.lastname}` };

        navigate(UrlsFront.SignUpContact, { state: { data: params } });
      })
      .catch(setErrorMessage);
  };

  return (
    <>
      <Titulo>Registro</Titulo>
      <BPFormProvider methods={methods} rules={SignUpOtpRules}>
        {loading && <Spinner width={40} my={'48px'} />}

        {!loading && (
          <VStack as="form" onSubmit={methods.handleSubmit(onSubmit)}>
            <Input label={EMAIL_LABEL} name="email" control={methods.control} readOnly />
            <Input name="otp" type="otp" control={methods.control} label={OTP_LABEL} otpBorderBottomWidth="1px" otpSeparatorColor="secondary.1" otpBorderColor="secondary.1" />

            <ErrorMessageContainer show={showError} errorMessage={errorMessage} mb={16} marginTop="8px" />

            <Button type="submit" variant="secondary" mt={'8px !important'}>
              Confirmar
            </Button>
          </VStack>
        )}
      </BPFormProvider>

      <AuthLink show={!loading} />
    </>
  );
};
